import { useTheme } from '@mui/material';
import { ROUTES } from '../../constants/routes';
import { PageHeader } from '../layout/PageHeader';
import { ContentWrapper } from '../layout/styled';
import { OperatingPartnerTable } from './components/OperatingPartnerTable';
import { useAtomValue } from 'jotai';
import { isSmallScreenState } from '../../state/UIState';

export const OpManagerOperatingPartners = () => {
  const { colors } = useTheme();
  const isSmallScreen = useAtomValue(isSmallScreenState);

  return (
    <>
      <PageHeader
        title='Submitters'
        description=''
        breadcrumbs={[
          {
            title: 'All timesheet',
            url: `/${ROUTES.OP_MANAGER_ALL_TIMESHEETS}`,
            color: colors.textAccent.default,
          },
          {
            title: 'Submitters',
          },
        ]}
      />
      <ContentWrapper isSmallScreen={isSmallScreen}>
        <OperatingPartnerTable />
      </ContentWrapper>
    </>
  );
};
